var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / WW") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-WW",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#19BFBF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,2.66666667 C18.0500882,2.66666667 21.3333333,5.94991183 21.3333333,10 C21.3333333,14.0500882 18.0500882,17.3333333 14,17.3333333 C9.94991183,17.3333333 6.66666667,14.0500882 6.66666667,10 C6.66666667,5.94991183 9.94991183,2.66666667 14,2.66666667 Z M15.9856661,10.6661902 L12.0143339,10.6661902 C12.1116466,12.9160261 12.6991724,14.904402 13.6152191,15.988674 C13.7422624,15.9959071 13.8706532,16 14,16 C14.129009,16 14.2570671,15.9959284 14.3840527,15.9879067 C15.3008276,14.904402 15.8883534,12.9160261 15.9856661,10.6661902 Z M19.9634096,10.6664062 L17.3203106,10.6666241 C17.2471683,12.5281062 16.8673571,14.2531311 16.2172158,15.5771951 C18.235852,14.7740617 19.7159377,12.9059653 19.9634096,10.6664062 Z M10.6796894,10.6666241 L8.0365904,10.6664062 C8.28407851,12.9061116 9.76434132,14.7743058 11.7838235,15.5774334 C11.1326429,14.2531311 10.7528317,12.5281062 10.6796894,10.6666241 Z M11.7830985,4.42216496 L11.6645292,4.47150974 C9.70622025,5.29980459 8.27918313,7.13822078 8.0365914,9.33358476 L10.6796915,9.33332048 C10.7528511,7.47155962 11.1327717,5.74629988 11.7830985,4.42216496 Z M16.2165722,4.42272397 L16.2598837,4.511091 C16.8839731,5.82309618 17.2487758,7.51295938 17.3203085,9.33332048 L19.9634086,9.33358476 C19.7159337,7.09402966 18.2358493,5.22593719 16.2165722,4.42272397 Z M14,4 C13.8706532,4 13.7422624,4.00409294 13.6149501,4.01215638 C12.6991698,5.09590692 12.1118101,7.08364795 12.0143774,9.33280477 L15.9856226,9.33280477 C15.8881899,7.08364795 15.3008302,5.09590692 14.385106,4.01171084 C14.2570671,4.0040716 14.129009,4 14,4 Z",
    id: "Oval-143",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWw);
export default __webpack_public_path__ + "static/media/WW.3ab99b55403c3f702463841e7413c1ca.svg";
export { ForwardRef as ReactComponent };